// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"06c8bf75","626":"bb54ac45","627":"380ad41b","651":"6c20893d","726":"b4e94bc0"}[chunkId] + ".chunk.js";
};